import { render, staticRenderFns } from "./EvDialog.vue?vue&type=template&id=6f80e6a5&lang=pug"
import script from "./EvDialog.vue?vue&type=script&lang=js"
export * from "./EvDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports